import React from "react";
import { Container } from "@mantine/core";
import ChatBox from "../components/shared/chat-box";
import { useLocation } from "react-router-dom";

export interface AiAssistantScreenProps {
  companyId: string;
}

export function AiAssistantScreen({ companyId }: AiAssistantScreenProps) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div 
      style={{ 
        height: "calc(100vh - 70px - 32px)", 
        display: "flex", 
        flexDirection: "column",
        maxWidth: 1200,
        padding: 0
      }}
    >
      <ChatBox 
        companyId={companyId} 
        currentPath={currentPath} 
        mode="full" 
      />
    </div>
  );
}

export default AiAssistantScreen;
